import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { platformType } from '../../../../../core/utils/platform-type';

import {
  AcceptedWhenRow,
  AcceptedWhenTimestamp,
  AcceptedWhenTitle,
  ConsentFormLine,
  ConsentFormLink,
  ConsentFormTitle,
  Container,
  ConsentFormList,
  Text,
  UserInterviewsMessage,
  Image,
} from './style';

const noConsentFormMessage = "You didn't add a consent form to this project.";

const ParticipantConsentForm = ({
  consentForms,
  qualifiedAt,
  showUserInterviewsRecruited,
}) => (
  <Container>
    {qualifiedAt && (
      <AcceptedWhenRow>
        <AcceptedWhenTitle>
          Accepted on
        </AcceptedWhenTitle>
        <AcceptedWhenTimestamp>
          {moment(qualifiedAt).format('MMMM D YYYY')}
          {' '}
          at
          {' '}
          {moment(qualifiedAt).format('hh:mm A')}
        </AcceptedWhenTimestamp>
      </AcceptedWhenRow>
    )}
    {consentForms.length > 0 && (
      <ConsentFormList>
        {
          consentForms.map(({ consentForm }) => (
            <ConsentFormLine>
              <ConsentFormTitle>
                {consentForm.name}
              </ConsentFormTitle>
              <ConsentFormLink
                href={consentForm.filePath}
                target="_blank"
              >
                View
              </ConsentFormLink>
            </ConsentFormLine>
          ))
        }
      </ConsentFormList>
    )}
    {consentForms.length <= 0 && (
      <Text>
        {noConsentFormMessage}
      </Text>
    )}

    {platformType === 'company' && showUserInterviewsRecruited && (
      <UserInterviewsMessage>
        Participant recruited by
        <Image src="/images/user-interviews-logo.svg" alt="User Interviews" />
      </UserInterviewsMessage>
    )}
  </Container>
);

// proptypes
ParticipantConsentForm.propTypes = {
  consentForms: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    fileUrl: PropTypes.string,
  })),
  qualifiedAt: PropTypes.string,
  showUserInterviewsRecruited: PropTypes.bool,
};

// default props
ParticipantConsentForm.defaultProps = {
  consentForms: [],
  qualifiedAt: null,
  showUserInterviewsRecruited: false,
};

export default ParticipantConsentForm;
